__turbopack_context__.v({
  "confirmation": "copy-to-clipboard-module-scss-module__BvjtZa__confirmation",
  "copyIcon": "copy-to-clipboard-module-scss-module__BvjtZa__copyIcon",
  "copyToClipboard": "copy-to-clipboard-module-scss-module__BvjtZa__copyToClipboard",
});
